import { defineCustomElement } from 'vue'
import carbonZero from '@/components/CarbonZero.ce.vue'
import 'vue-skeletor/dist/vue-skeletor.css'

const CarbonZero = defineCustomElement(carbonZero)

customElements.define('carbon-zero', CarbonZero)

export default CarbonZero
